// src/lib/arrivalGate.js — 출발 전 정류장 도착 차단 판정 (순수 · Firebase import 0)
// ---------------------------------------------------------------------------
// 🔴 서버 정본 = functions/arrivalGate.js 와 같은 규칙. 한쪽만 고치지 말 것
//    (scripts/test_arrival_gate.cjs 가 두 구현을 대조).
// 기사앱이 출발 전에 정류장을 «도착 처리(visitedStops 등록)» 해 버리면 서버가 거부해도
// 실제 운행 때 그 정류장을 다시 감지하지 않는다 → 클라도 같은 판정으로 아예 표시하지 않는다.
// 배경·규칙 설명은 서버 파일 머리 참고.
// 2026-10-30: originArrived(기점 도착 기록 여부) 인자 추가 — 출발 직전 여유 구간 판정에 쓴다.
// ---------------------------------------------------------------------------

export const PRE_DEPART_MARGIN_MIN = 5;

/** "YYYY-MM-DD" + "HH:MM"(KST) → epoch ms. 형식 불량이면 null. */
export function kstDepartMs(dateStr, hhmm) {
  if (typeof dateStr !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return null;
  if (typeof hhmm !== "string") return null;
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm.trim());
  if (!m) return null;
  const h = +m[1], mi = +m[2];
  if (h > 23 || mi > 59) return null;
  const ms = Date.parse(`${dateStr}T${String(h).padStart(2, "0")}:${m[2]}:00+09:00`);
  return isFinite(ms) ? ms : null;
}

/** 출발 전이라 이 도착을 기록하지 않아야 하면 true. */
export function preDepartureBlocked({ departMs, nowMs, isOrigin, viaBackfill, marginMin, originArrived }) {
  if (typeof departMs !== "number" || !isFinite(departMs)) return false;
  if (typeof nowMs !== "number" || !isFinite(nowMs)) return false;
  const margin = (typeof marginMin === "number" && isFinite(marginMin) && marginMin >= 0)
    ? marginMin : PRE_DEPART_MARGIN_MIN;
  if (nowMs >= departMs) return false;
  if (isOrigin === true && !viaBackfill) return false;
  if (nowMs < departMs - margin * 60 * 1000) return true;
  // 출발 직전 여유 구간: 기점 도착이 이미 있으면(=기점에서 출발한 뒤) 기록, 없으면(=기점으로 가는 길) 차단.
  // 기점 도착 여부를 모르는 호출(originArrived 미전달)은 종전대로 기록한다.
  return originArrived === false;
}
